"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _sitecoreJssReact = require("@sitecore-jss/sitecore-jss-react");
var _headTags = _interopRequireDefault(require("../components/headTags"));
var _Footer = _interopRequireDefault(require("../components/Nav/Footer"));
var _Header = _interopRequireDefault(require("../components/Nav/Header"));
var _lodash = require("lodash");
var _reactBootstrap = require("react-bootstrap");
var _richTextField = require("../lib/richTextField");
var _dateFns = require("date-fns");
var _globalDataContext = require("../lib/globalDataContext");
var _linkFieldSrc = require("../lib/linkFieldSrc");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/*
  APP LAYOUT
  This is where the app's HTML structure and root placeholders should be defined.
  This layout is for Press release template routes.
*/

var PressReleaseLayout = props => {
  var route = props.route;
  (0, _globalDataContext.setGlobalData)(props);
  var BreadcrumbItem = () => {
    var breadCrumbList = route.fields.Breadcrumb.fields.BreadcrumbList;
    if (breadCrumbList && breadCrumbList.length > 0) {
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
        className: "mm-spacing--minor"
      }), /*#__PURE__*/_react.default.createElement("nav", {
        "aria-label": "breadcrumb"
      }, /*#__PURE__*/_react.default.createElement("ol", {
        className: "breadcrumb"
      }, breadCrumbList.map((crumb, index) => {
        var {
          linkUrl,
          linkTarget,
          linkAlt
        } = (0, _linkFieldSrc.linkFieldSrc)(crumb.fields.LinkSrc.value);
        return /*#__PURE__*/_react.default.createElement("li", {
          key: index,
          className: "breadcrumb-item"
        }, /*#__PURE__*/_react.default.createElement("a", {
          href: "".concat(linkUrl),
          title: linkAlt,
          target: linkTarget
        }, crumb.fields.Label.value));
      }))));
    } else {
      return null;
    }
  };
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_headTags.default, props.headTagsProps), /*#__PURE__*/_react.default.createElement(_sitecoreJssReact.VisitorIdentification, null), /*#__PURE__*/_react.default.createElement(_Header.default, {
    route: route,
    params: props.componentProps,
    headTagsProps: props.headTagsProps
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "container mm-spacing"
  }, route.fields.ShowBreadcrumb.value && route.fields.Breadcrumb && /*#__PURE__*/_react.default.createElement(BreadcrumbItem, null), !(0, _lodash.isEmpty)(route.fields.Headline.value) && /*#__PURE__*/_react.default.createElement("h1", null, route.fields.Headline.value), /*#__PURE__*/_react.default.createElement("div", {
    className: "app-container"
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Row, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
    md: 8
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "app-container"
  }, !(0, _lodash.isEmpty)(route.fields.PostDate.value) && /*#__PURE__*/_react.default.createElement("p", null, (0, _dateFns.format)(new Date(route.fields.PostDate.value), 'MMMM do, yyyy'))), /*#__PURE__*/_react.default.createElement("div", {
    className: "mm-spacing"
  }), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Row, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
    md: 12
  }, (0, _richTextField.parseHTML)(route.fields.Body)))), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
    md: 4
  }, /*#__PURE__*/_react.default.createElement(_sitecoreJssReact.Placeholder, {
    name: "right-rail",
    rendering: route,
    params: props.componentProps
  }))))), /*#__PURE__*/_react.default.createElement("div", {
    className: "mm-spacing"
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "container mm-spacing"
  }, (0, _richTextField.parseHTML)(route.fields.Disclosure)), /*#__PURE__*/_react.default.createElement(_Footer.default, {
    fields: route.fields,
    componentParams: props.componentProps,
    params: props.headTagsProps
  }));
};
var _default = exports.default = PressReleaseLayout;